import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface UpdateWarehouseIntegrationInterface {
  apiKey?: string
  baseUrl?: string
  clientId?: string
  clientSecret?: string
  clientSecretGeneratedAtUtc?: string
  name?: string
  token?: string
  warehouseId?: string
}

export const useAddWarehouseIntegration = () => {
  const mutate = useMutation(
    ({
      baseUrl,
      apiKey,
      clientId,
      clientSecret,
      clientSecretGeneratedAtUtc,
      name,
      token,
      warehouseId,
    }: UpdateWarehouseIntegrationInterface) => {
      return postAPI(`/Warehouse/${warehouseId}/Integration/${name}`, {
        baseUrl,
        apiKey: name === 'IcsWMS' ? apiKey : undefined,
        token: name === 'PaperlessWMS' ? token : undefined,
        /** BDA (B-Connect) only — the API encrypts clientId/clientSecret server-side. */
        clientId: name === 'BDA' ? clientId : undefined,
        clientSecret: name === 'BDA' ? clientSecret : undefined,
        clientSecretGeneratedAtUtc:
          name === 'BDA' ? clientSecretGeneratedAtUtc : undefined,
      })
    },
  )

  return mutate
}

export default useAddWarehouseIntegration
